import script from "./DocumentUploadView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentUploadView.vue?vue&type=script&setup=true&lang=js"

import "./DocumentUploadView.vue?vue&type=style&index=0&id=083a79dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-083a79dc"]])

export default __exports__